<template>
  <Carousel v-bind="config" class="chat-widget__carousel">
    <Slide v-for="slide in images" :key="slide.title">
      <div class="chat-widget__slide-content">
        <img :src="slide.url" :alt="slide.title" />
        <small>{{ slide.title }}</small>
      </div>
    </Slide>

    <template #addons>
      <Navigation />
      <Pagination />
    </template>
  </Carousel>
</template>

<script setup>
import 'vue3-carousel/dist/carousel.css'
import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel'
import { defineProps } from 'vue'

const config = {
  itemsToShow: 4.5,
  wrapAround: true,
  gap: 10,
  // 'breakpointMode' determines how the carousel breakpoints are calculated
  // Acceptable values: 'viewport' (default) | 'carousel'
  // 'viewport' - breakpoints are based on the viewport width
  // 'carousel' - breakpoints are based on the carousel width
  breakpointMode: 'viewport',

  // Breakpoints are mobile-first
  // Any settings not specified will fall back to the carousel's default settings
  breakpoints: {
    // 300px and up
    300: {
      itemsToShow: 1.5,
      snapAlign: 'center',
    },
    500: {
      itemsToShow: 2.5,
      snapAlign: 'center',
    },
    // 400px and up
    790: {
      itemsToShow: 3.5,
      snapAlign: 'start',
    },
    // 500px and up
    1200: {
      itemsToShow: 4.5,
      snapAlign: 'start',
    },
  },
}

const props = defineProps({
  images: {
    type: Array,
    required: true,
    default: () => []
  }
})
</script>